import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    ValidateAddress,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/ValidateShippingAddressForm";

addToChainAfter(chain, ValidateAddress, async props => {
    console.log("ValidateShippingAddressForm", props.formErrors);
    // Dispatch to the custom MyAccount action instead of CheckoutShipping
    props.dispatch({
        type: "Components/MyAccount/SetNewShippingAddressFormErrors",
        formErrors: props.formErrors,
    });
});

